export const MAIN_SITE_URL = "https://kaspreadsheet.com";

export interface Category {
  id: string;
  url: string;
  image: string;
}

export const categories: Category[] = [
  {
    id: "shoes",
    url: "https://kaspreadsheet.com/category-911-Shoes.html",
    image:
      "https://readdy.ai/api/search-image?query=Pair%20of%20white%20leather%20sneakers%20with%20red%20accents%20standing%20on%20a%20smooth%20light%20grey%20concrete%20floor%2C%20crisp%20daylight%20from%20the%20side%2C%20clean%20minimal%20product%20photography%20with%20high%20detail%20and%20a%20soft%20drop%20shadow&width=600&height=600&seq=cat-shoes-01&orientation=squarish&nocache=true",
  },
  {
    id: "hoodies",
    url: "https://kaspreadsheet.com/search-912/name/Shoes.html",
    image:
      "https://readdy.ai/api/search-image?query=Cozy%20sage%20green%20hoodie%20hanging%20on%20a%20wooden%20hanger%20against%20a%20soft%20pastel%20pink%20studio%20wall%2C%20gentle%20natural%20window%20light%2C%20warm%20minimal%20fashion%20photography%20with%20high%20detail&width=600&height=600&seq=cat-hoodies-01&orientation=squarish&nocache=true",
  },
  {
    id: "tshirts",
    url: "https://kaspreadsheet.com/search-913/name/Shoes.html",
    image:
      "https://readdy.ai/api/search-image?query=Neatly%20folded%20stack%20of%20colorful%20cotton%20t-shirts%20in%20mustard%2C%20terracotta%20and%20cream%20on%20a%20mint%20green%20table%2C%20soft%20diffused%20daylight%2C%20bright%20cheerful%20minimal%20product%20photography&width=600&height=600&seq=cat-tshirts-01&orientation=squarish&nocache=true",
  },
  {
    id: "jackets",
    url: "https://kaspreadsheet.com/search-914/name/Shoes.html",
    image:
      "https://readdy.ai/api/search-image?query=Classic%20blue%20denim%20jacket%20draped%20over%20a%20dark%20green%20chair%20in%20a%20cozy%20corner%2C%20warm%20afternoon%20light%2C%20editorial%20lifestyle%20product%20photography%20with%20high%20detail&width=600&height=600&seq=cat-jackets-01&orientation=squarish&nocache=true",
  },
  {
    id: "pants",
    url: "https://kaspreadsheet.com/search-915/name/Shoes.html",
    image:
      "https://readdy.ai/api/search-image?query=Rolled%20dark%20denim%20jeans%20and%20light%20grey%20joggers%20arranged%20on%20a%20warm%20oak%20wooden%20table%20top%2C%20soft%20natural%20side%20light%2C%20minimal%20textile%20product%20photography%20with%20high%20detail&width=600&height=600&seq=cat-pants-01&orientation=squarish&nocache=true",
  },
  {
    id: "headwear",
    url: "https://kaspreadsheet.com/search-916/name/Shoes.html",
    image:
      "https://readdy.ai/api/search-image?query=Collection%20of%20casual%20baseball%20caps%20and%20a%20knitted%20beanie%20on%20a%20light%20blue%20shelf%20against%20a%20pale%20sky%20wall%2C%20soft%20even%20lighting%2C%20minimal%20accessory%20product%20photography&width=600&height=600&seq=cat-headwear-01&orientation=squarish&nocache=true",
  },
  {
    id: "sets",
    url: "https://kaspreadsheet.com/search-917/name/Shoes.html",
    image:
      "https://readdy.ai/api/search-image?query=Matching%20athleisure%20tracksuit%20set%20displayed%20on%20a%20minimal%20mannequin%20against%20a%20soft%20warm%20yellow%20background%2C%20clean%20studio%20lighting%2C%20modern%20fashion%20product%20photography%20with%20high%20detail&width=600&height=600&seq=cat-sets-01&orientation=squarish&nocache=true",
  },
  {
    id: "underwear",
    url: "https://kaspreadsheet.com/search-918/name/Shoes.html",
    image:
      "https://readdy.ai/api/search-image?query=Tidy%20stack%20of%20soft%20cotton%20underwear%20in%20white%20and%20lavender%20tones%20on%20a%20pale%20lilac%20surface%2C%20gentle%20diffused%20light%2C%20clean%20minimal%20textile%20product%20photography&width=600&height=600&seq=cat-underwear-01&orientation=squarish&nocache=true",
  },
  {
    id: "jersey",
    url: "https://kaspreadsheet.com/search-919/name/Shoes.html",
    image:
      "https://readdy.ai/api/search-image?query=Bold%20red%20and%20white%20sports%20jersey%20hanging%20on%20a%20metal%20hanger%20against%20a%20deep%20charcoal%20background%2C%20dramatic%20soft%20spotlight%2C%20sporty%20product%20photography%20with%20high%20detail&width=600&height=600&seq=cat-jersey-01&orientation=squarish&nocache=true",
  },
  {
    id: "accessories",
    url: "https://kaspreadsheet.com/search-920/name/Shoes.html",
    image:
      "https://readdy.ai/api/search-image?query=Flat%20lay%20of%20a%20minimal%20wristwatch%2C%20sunglasses%20and%20a%20thin%20bracelet%20on%20cream%20marble%20texture%2C%20soft%20even%20daylight%2C%20elegant%20accessory%20product%20photography&width=600&height=600&seq=cat-accessories-01&orientation=squarish&nocache=true",
  },
  {
    id: "bags",
    url: "https://kaspreadsheet.com/search-921/name/Shoes.html",
    image:
      "https://readdy.ai/api/search-image?query=Stylish%20tan%20canvas%20backpack%20leaning%20against%20a%20white%20brick%20wall%20on%20a%20wooden%20floor%2C%20soft%20natural%20light%2C%20minimal%20bag%20product%20photography%20with%20high%20detail&width=600&height=600&seq=cat-bags-01&orientation=squarish&nocache=true",
  },
  {
    id: "belts",
    url: "https://kaspreadsheet.com/search-922/name/Shoes.html",
    image:
      "https://readdy.ai/api/search-image?query=Two%20rolled%20leather%20belts%20in%20brown%20and%20black%20on%20a%20warm%20tan%20leather%20surface%2C%20soft%20side%20lighting%2C%20minimal%20leather%20goods%20product%20photography&width=600&height=600&seq=cat-belts-01&orientation=squarish&nocache=true",
  },
  {
    id: "perfumes",
    url: "https://kaspreadsheet.com/search-923/name/Shoes.html",
    image:
      "https://readdy.ai/api/search-image?query=Elegant%20amber%20glass%20perfume%20bottle%20with%20soft%20gold%20lighting%20on%20a%20dark%20moody%20background%2C%20refined%20luxury%20product%20photography%20with%20high%20detail&width=600&height=600&seq=cat-perfumes-01&orientation=squarish&nocache=true",
  },
  {
    id: "other",
    url: "https://kaspreadsheet.com/search-924/name/Shoes.html",
    image:
      "https://readdy.ai/api/search-image?query=Assorted%20streetwear%20fashion%20items%20including%20a%20tee%2C%20socks%20and%20a%20cap%20arranged%20on%20a%20neutral%20light%20grey%20surface%2C%20soft%20daylight%2C%20minimal%20flat%20lay%20product%20photography&width=600&height=600&seq=cat-other-01&orientation=squarish&nocache=true",
  },
];